import axios from 'axios';
import ambiente from './ambiente';

const api = axios.create({
  baseURL: ambiente.URL_API_PORTAL
});

export default api;